/* eslint-disable max-len */

export default {
  Profile: 'Profile',
  'Save profile': 'Save profile',
  'Password is not secure enough': 'Password is not secure enough',

  // Chats
  Chats: 'Chats',
  'Chat Info': 'Chat Info',
  'View older messages': 'View older messages',
  'You cannot send new message at this time': 'You cannot send new message at this time',
  'The client has been blocked from sending new messages': 'The client has been blocked from sending new messages',
  'Write a message': 'Write a message…',
  'Max. message length is {n} characters': 'Max. message length is {n} characters',
  'Add Attachment': 'Add Attachment',
  'Text Snippets': 'Text Snippets',
  Send: 'Send',
  'Send Message (Ctrl+Enter or ⌘+Enter), Enter to add a linebreak': 'Send Message (Ctrl+Enter or ⌘+Enter), Enter to add a linebreak',
  'File attachment': 'File attachment',
  'Attached form': 'Attached form',
  'Message must contain text': 'Message must contain text',
  'Chat Error': 'Chat Error',
  'File attachment error': 'File attachment error',
  'Max file size is {n}': 'Max file size is {n}',
  'Chat notification': 'Chat notification',
  'Message read by': 'Message read by',
  Copy: 'Copy',
  Edit: 'Edit',
  Delete: 'Delete',
  'Message has been deleted': 'Message has been deleted',
  'edited at': 'edited at',
  'Form not found': 'Form not found',
  'Download file': 'Download file',
  'The text has been copied to clipboard.': 'The text has been copied to clipboard.',
  'Delete message?': 'Delete message?',
  'Do you really want to delete this message?': 'Do you really want to delete this message?',
  'Error deleting message': 'Error deleting message',
  'Edit message': 'Edit message',
  'Message updated': 'Message updated',
  'Error saving message': 'Error saving message',

  mobile: {
    'Quantum app': 'Quantum app',
    'Please enter a code': 'Please enter a code',
    'Access code': 'Access code',
    Email: 'Email',
    Enter: 'Enter',
    'Error getting company by code': 'Error getting company by code',
    'Forgot password': 'Forgot password',
    Login: 'Login',
    'First name': 'First name',
    'Last name': 'Last name',
    Birthdate: 'Birthdate',
    Password: 'Password',
    'Don\'t have an account yet?': 'Don\'t have an account yet?',
    'Sign up': 'Sign up',
    'Please enter a valid email': 'Please enter a valid email',
    'Please enter a first name': 'Please enter a first name',
    'Please enter a last name': 'Please enter a last name',
    'Please enter a password': 'Please enter a password',
    'Please enter a valid password': 'Please enter a valid password',
    'Please enter a valid birthdate': 'Please enter a valid birthdate',
    'Error while login': 'Error while login',
    'Forgot your password?': 'Forgot your password?',
    'Enter your email to set a new one': 'Enter your email to set a new one',
    'Please enter an email': 'Please enter an email',
    'Send email': 'Send email',
    'Go to login page': 'Go to login page',
    'Thank you. If the email you entered exists in our systems, we will send you an email with instruction on how to reset your password': 'Thank you. If the email you entered exists in our systems, we will send you an email with instruction on how to reset your password',
    'Did not receive any email?': 'Did not receive any email? Wait a few minutes or {action}',
    'try again': 'try again',
    'Already have an account? Login': 'Already have an account? Login',
    Index: 'Index',
    Home: 'Home',
    Close: 'Close',
    Learn: 'Learn',
    Chat: 'Chat',
    Forms: 'Forms',
    Form: 'Form',
    'My Benefits': 'My Benefits',
    Share: 'Share',
    Account: 'Account',
    'My Account': 'My Account',
    'Stay up to date': 'Stay up to date',
    Logout: 'Logout',
    'Articles not found': 'Articles not found',
    Search: 'Search',
    'Showing {count} results': 'Showing {count} result | Showing {count} result | Showing {count} results',
    'Enter a topic': 'Enter a topic...',
    'No results found': 'No results found',
    'Clear search': 'Clear search',
    Article: 'Article',
    Submissions: 'Submissions',
    'Subscribe to the employee newsletter': 'Subscribe to the employee newsletter',
    'Form submitted successfully. Thank you!': 'Form submitted successfully. Thank you!',
    'The newsletter provides regular updates and information about the EAP services available to employees, including counseling, mental health resources, and work - life balance support.': 'The newsletter provides regular updates and information about the EAP services available to employees, including counseling, mental health resources, and work - life balance support.',
    'Receive the newsletter via email': 'Receive the newsletter via email',
    'Save preferences': 'Save preferences',
    'Past issues of the newsletter': 'Past issues of the newsletter',
    'Failed to load newsletters': 'Failed to load newsletters',
    'Failed to get user profile': 'Failed to get user profile',
    'Settings saved': 'Settings saved',
    Profile: 'Profile',
    Locale: 'Locale',
    'Mobile phone (for notifications)': 'Mobile phone (for notifications)',
    'Old password': 'Old password',
    'Old password field is required': 'Old password field is required',
    'Please use minimum {min} symbols ({max} maximum)': 'Please use minimum {min} symbols ({max} maximum)',
    'New password': 'New password',
    'Save profile': 'Save profile',
    'Change password': 'Change password',
    'Manage my newsletter subscription': 'Manage my newsletter subscription',
    'Delete account': 'Delete account',
    'Profile saved successfully': 'Profile saved successfully',
    'Please fill out all required fields': 'Please fill out all required fields',
    'The request has been sent': 'The request has been sent',
    'Request account deletion': 'Request account deletion',
    'We will delete your account and all associated data, with the exception of data that we might be legally required to store.': 'We will delete your account and all associated data, with the exception of data that we might be legally required to store.',
    Confirm: 'Confirm',
    'Do you really want to logout?': 'Do you really want to logout?',
  },
};
